// FinancialParams.js
import React from 'react';
import PropTypes from 'prop-types';
import styles from './TraderDashboard.module.css';

const FinancialParams = ({ params, onInputChange }) => (
  <div className={`${styles.gridContainer} ${styles.financialGridContainer}`}>
    <label className={styles.fieldLabel}>Initial Capital ($)</label>
    <label className={styles.fieldLabel}>Top Assets (#)</label>
    <label className={styles.fieldLabel}>Max DD (%)</label>
    <label className={styles.fieldLabel}>Risk-Free Rate (%)</label>
    <input
      type="number"
      name="initial_capital"
      value={params.initial_capital}
      onChange={onInputChange}
      className={`${styles.formInput} ${styles.gridInput}`}
      required
      min="100"
      step="100"
    />
    <input
      type="number"
      name="n_top_performers"
      value={params.n_top_performers}
      onChange={onInputChange}
      className={`${styles.formInput} ${styles.gridInput}`}
      required
      min="1"
      max="50"
    />
    <input
      type="number"
      name="drawdown_threshold"
      value={params.drawdown_threshold}
      onChange={onInputChange}
      className={`${styles.formInput} ${styles.gridInput}`}
      required
      step="0.01"
      min="0"
      max="100"
    />
    <input
      type="number"
      name="risk_free_rate"
      value={params.risk_free_rate}
      onChange={onInputChange}
      className={`${styles.formInput} ${styles.gridInput}`}
      required
      step="0.001"
      min="0"
      max="50"
    />
  </div>
);

FinancialParams.propTypes = {
  params: PropTypes.shape({
    initial_capital: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    n_top_performers: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    drawdown_threshold: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    risk_free_rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default FinancialParams;